export const trimTransform = (value) => (value && value.trim ? value.trim() : value);
